const awsconfig = {
  Auth: {
    Cognito: {
      userPoolId: "us-east-1_saiwaLaQ8",
      userPoolClientId: "305l360o3obsg6mk38sdihr9vm",
      identityPoolId: "us-east-1:e0128574-026c-4625-bd79-5401694220cc",
    },
    region: "us-east-1",
  },
  API: {
    REST: {
      vivawell: {
        endpoint: "https://gsqeuj6myb.execute-api.us-east-1.amazonaws.com/prod",
        region: "us-east-1",
      },
    },
    Events: {
      endpoint:
        "https://b6rwxr5npzccxcfrsokfhvigu4.appsync-api.us-east-1.amazonaws.com/event",
      region: "us-east-1",
      defaultAuthMode: "iam" as const,
    },
  },
};

export default awsconfig;
